const ActivationLocationType = {
	PANEL: 'PANEL',
	COMPONENT: 'COMPONENT',
};

export { ActivationLocationType };
